// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-container[data-v-0763e1e2]{display:flex}.message-icon[data-v-0763e1e2]{min-width:2.6rem}.message-body[data-v-0763e1e2]{flex-grow:1}.extra-content[data-v-0763e1e2]{white-space:pre;max-height:300px;background-color:#ffd;border:1px solid #ccc;font-family:Courier New,Courier,monospace;font-size:.8rem;padding:.4rem;overflow:scroll}", ""]);
// Exports
module.exports = exports;
